// extracted by mini-css-extract-plugin
export default {"primaryFilled":"primaryFilledButton_primaryFilled__Q5WJB","primaryOutline":"primaryFilledButton_primaryOutline__w5nb-"};